import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyNoVendorDocsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportNoVendorDocsExcel = () => {
  const [fetchNoVendorDocs, { isLoading, isFetching }] =
    useLazyNoVendorDocsQuery();

  const handleDownload = async () => {
    try {
      const responseData = await fetchNoVendorDocs({}).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        "Shop Name": row?.shopName || "N/A",
        "Owner Name": row?.ownerName || "N/A",
        Phone: row?.phone || "N/A",
        Address: row?.address || "N/A",
        "Onboarded By": row?.onboardedBy || "N/A",
        "Added By": row?.addedUser || "N/A",
        "Relationship Manager": row?.relationshipManager || "N/A",
        "Referred By": row?.referredBy || "N/A",
        "Created At": row?.createdAt
          ? new Date(row?.createdAt).toLocaleDateString("en-US")
          : "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "No_Vendor_Docs_Report",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error(
        "Error fetching No Vendor Docs report data: " + error.message
      );
    }
  };

  return (
    <div style={{ paddingRight: "10px" }}>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportNoVendorDocsExcel;